import React, { useState } from "react";
import { Form, Input, Button, Row, Col, message, DatePicker, InputNumber } from "antd";
import moment from 'moment';
import { userUpdate } from "apis/user";

const ManualInvoiceExtendForm = ({ data = {}, onCancel, onCallback }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const disabledDate = (current) => {
    // Can not select days before today
    return (current && current < moment().endOf('day'));
  };

  return (
    <Form
      form={form}
      layout="vertical"
      name="extend-form"
      onFinish={async (values) => {
        try {
          setLoading(true);

          const item = {
            userId: data?.userId,
            endTime: values?.endTime,
            seat: values?.seat,
            source: "manual-invoice"
          };

          await userUpdate(item);
          onCallback();
          message.success("Team has been updated successfully");
        } catch (error) {
          console.error(error);
          message.success("Failed to update team");
        } finally {
          setLoading(false);
        }
      }}
      initialValues={{
        email: data?.email,
        source: data?.source,
        seat: data?.seat,
        endTime: moment(data?.endTime),
      }}
    >
      <div className="user-form">
        <Row gutter={24} type="flex">
          <Col lg={{ span: 12 }} xs={{ span: 24 }}>
            <Form.Item
              name="email"
              label={"Email"}
              rules={[
                {
                  required: true,
                  message: "Email!",
                },
                {
                  type: "email",
                  message: "Invalid email!",
                },
              ]}
            >
              <Input disabled={true} />
            </Form.Item>
          </Col>
          <Col lg={{ span: 12 }} xs={{ span: 24 }}>
            <Form.Item
              name="seat"
              label="Seat"
              rules={[
                {
                  required: true,
                  message: 'Seat!'
                }
              ]}
            >
              <InputNumber min={2} style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col lg={{ span: 12 }} xs={{ span: 24 }}>
            <Form.Item
              label="End date"
              name="endTime"
              rules={[
                {
                  required: true,
                  message: 'End date!'
                }
              ]}
            >
              <DatePicker
                disabledDate={disabledDate}
                style={{ width: '100%' }}
                placeholder="End date" />
            </Form.Item>
          </Col>
        </Row>
      </div>

      <div
        className="ant-modal-footer"
        style={{ marginLeft: -24, marginRight: -24, marginBottom: -24 }}
      >
        <Row gutter={24} type="flex" style={{ textAlign: "right" }}>
          <Col className="gutter-row" span={24} style={{ textAlign: "right" }}>
            <Button disabled={loading} type="clear" onClick={onCancel}>
              Cancel
            </Button>
            <Button disabled={loading} type="primary" htmlType="submit">
              Save
            </Button>
          </Col>
        </Row>
      </div>
    </Form>
  );
};

export default ManualInvoiceExtendForm;
